var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"has-text-weight-bold mr-sm"},[_vm._v(_vm._s(_vm.presenter.rank))]),_c('span',{class:_vm.presenter.changeTextClass},[_vm._v(_vm._s(_vm.presenter.rankChange))])])
}
var staticRenderFns = []

export { render, staticRenderFns }